module.exports = __webpack_public_path__ + "static/media/sheikhupura-dark.ac31bd47.svg";